import { createRouter, createWebHistory } from 'vue-router'
import { authGuard } from './guards'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/LoginView.vue'),
    },
    {
      path: '/',
      redirect: '/campaigns',
    },
    {
      path: '/campaigns',
      name: 'campaigns',
      component: () => import('@/views/CampaignsView.vue'),
      beforeEnter: authGuard,
    },
    {
      path: '/campaigns/:id',
      name: 'dashboard',
      component: () => import('@/views/DashboardView.vue'),
      beforeEnter: authGuard,
    },
    {
      path: '/campaigns/:id/categories',
      redirect: (to) => ({ path: `/campaigns/${to.params.id}/stories` }),
    },
    {
      path: '/campaigns/:id/categories/:categoryId/edit',
      name: 'category-edit',
      component: () => import('@/views/CategoryEditView.vue'),
      beforeEnter: authGuard,
    },
    {
      path: '/campaigns/:id/stories',
      name: 'stories',
      component: () => import('@/views/StoriesView.vue'),
      beforeEnter: authGuard,
    },
    {
      path: '/campaigns/:id/stories/:storyId/edit',
      name: 'story-edit',
      component: () => import('@/views/StoryEditView.vue'),
      beforeEnter: authGuard,
    },
    {
      path: '/campaigns/:id/assets',
      name: 'assets',
      component: () => import('@/views/AssetsView.vue'),
      beforeEnter: authGuard,
    },
    {
      path: '/campaigns/:id/settings',
      name: 'settings',
      component: () => import('@/views/SettingsView.vue'),
      beforeEnter: authGuard,
    },
    {
      path: '/campaigns/:id/templates',
      name: 'templates',
      component: () => import('@/views/TemplatesView.vue'),
      beforeEnter: authGuard,
    },
    {
      path: '/campaigns/:id/templates/new',
      name: 'template-new',
      component: () => import('@/views/TemplateNewView.vue'),
      beforeEnter: authGuard,
    },
    {
      path: '/campaigns/:id/templates/:templateId/edit',
      name: 'template-edit',
      component: () => import('@/views/TemplateEditView.vue'),
      beforeEnter: authGuard,
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/campaigns',
    },
  ],
})

export default router
